import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "w-fit relative flex items-center gap-2 px-3 py-2 rounded-md text-xs font-semibold bg-error-50 text-main-5 z-10"
};
export default {
  __name: 's-infotooltip-element',
  props: {
    message: {
      type: String,
      required: true
    },
    position: {
      type: String
    },
    // top, bottom, left, right | top-start, top-end ...
    floating: Boolean
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["w-fit relative rounded-md", {
          'shadow-weak_material': props.floating
        }])
      }, [_createElementVNode("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("i", {
        class: "icon-exclamation-rounded text-base"
      }, null, -1)), _createTextVNode(" " + _toDisplayString(props.message), 1)]), props.position ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["absolute h-4 w-4 bg-error-50 rotate-45", [{
          'top-1/2 -translate-y-1/2 -left-0.5': props.position === 'right'
        }, {
          'top-1/2 -translate-y-1/2 -right-0.5': props.position === 'left'
        }, {
          'left-1/2 -translate-x-1/2 -top-0.5': props.position === 'bottom'
        }, {
          'left-1/2 -translate-x-1/2 -bottom-0.5': props.position === 'top'
        }]])
      }, null, 2)) : _createCommentVNode("", true)], 2);
    };
  }
};